import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

import './styles.scss';
import { MyPagination } from '..';

const { Column } = Table;
const ITEM_PER_PAGE = 10;

const MyTable = ({
  className,
  data,
  columns,
  totalItem,
  onChange,
  onChangePagination,
  pageSize,
  currentPage,
  showHeader = true,
  loading = false,
  scroll = {},
  ...restProps
}) => {
  return (
    <div className={`my-table  ${className || ''}`}>
      <Table
        {...restProps}
        dataSource={data}
        rowClassName="my-table-header"
        pagination={false}
        showHeader={showHeader}
        loading={loading}
        scroll={scroll}
        rowKey={(row) => {
          return row.key || row.id;
        }}
        onChange={onChange}
      >
        {columns.map((column) => (
          <Column
            {...column}
            className={column.className}
            title={column.title}
            key={column.key}
            dataIndex={column.key}
            render={column.render}
            align={column.align}
          />
        ))}
      </Table>
      {totalItem !== 0 && (
        <MyPagination
          currentPage={currentPage}
          totalItem={totalItem}
          pageSize={pageSize}
          onChange={(data) => {
            onChangePagination(data);
          }}
        />
      )}
    </div>
  );
};

export default MyTable;

MyTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  className: PropTypes.string,
  totalItem: PropTypes.number,
  currentPage: PropTypes.number,
  onChange: PropTypes.func,
  showHeader: PropTypes.bool,
  loading: PropTypes.bool,
  scroll: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

MyTable.defaultProps = {
  totalItem: 0,
  currentPage: 1,
  pageSize: ITEM_PER_PAGE,
  onChange: () => {},
  onChangePagination: () => (page) => console.log(page),
};
